import '../styles/latex.css';
function Latex() {
	return <span className="latex">L<sup>A</sup>T<sub>E</sub>X</span>;
}

export default Latex; 